var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Sua vistoria de assistência técnica foi agendada com sucesso.")]),_vm._v(" "),_c('AssistanceSummary',{attrs:{"items":_vm.reasons,"accompanied":_vm.accompanied,"date":_vm.date,"address":_vm.address,"ticketCreationNotice":_vm.ticketCreationNotice}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d00db4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/support/ticket/technicalAssistance/ConcludedStep.vue
// module id = null
// module chunks = 